export default __webpack_public_path__ + "static/media/angle-thin-right.2736d31c.svg";